// CSS Modules - component class name prefix: WishListLink__

<template>
  <a
    :class="[$style.link, { WishListLink__disabled: isDisabled }]"
    @click="handleClick"
  >
    <i class="fas fa-file-medical"></i>{{ config.text }}
  </a>
</template>

<script>
import * as Storage from "../../shared/Storage";

export default {
  name: "WishListLink",
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isDisabled: false,
      wishList: null,
      badge: null,
      wishListItem: null,
      willUpdateBadge: true
    };
  },
  methods: {
    handleClick() {
      this.willUpdateBadge = true;
      if (!this.isDisabled) {
        this.wishListItem = this.config.item;
        if (this.wishListItem.flag) {
          this.wishListItem.flag = this.wishListItem.flag.replace(
            "big",
            "small"
          );
        }
        if (this.wishList) {
          const wishListItemIdx = this.wishList.findIndex(
            listItem => listItem.title === this.wishListItem.title
          );

          if (wishListItemIdx > -1) {
            this.wishList[wishListItemIdx].downloads.push(
              ...this.getDownloadsArray()
            );
            this.willUpdateBadge = false;
          } else {
            this.wishList.push({
              section: this.wishListItem.section,
              title: this.wishListItem.title,
              subTitle: this.wishListItem.subTitle,
              types: this.wishListItem.types,
              downloads: this.getDownloadsArray()
            });
          }
          Storage.setLocalStorage("wishList", this.wishList, true);
        } else {
          Storage.setLocalStorage(
            "wishList",
            [
              {
                title: this.wishListItem.title,
                subTitle: this.wishListItem.subTitle,
                section: this.wishListItem.section,
                types: this.wishListItem.types,
                downloads: this.getDownloadsArray()
              }
            ],
            true
          );
        }
        this.isDisabled = true;
        if (this.willUpdateBadge) {
          this.updateBadge();
        }
        window.dispatchEvent(this.event);
      }
    },
    getDownloadsArray() {
      return this.wishListItem.downloads.map(downloadItem => {
        return {
          url: downloadItem.url,
          flag: downloadItem.flag,
          languageCodes: Array.isArray(downloadItem.language)
            ? downloadItem.language
            : [downloadItem.language]
        };
      });
    },
    checkLocalStorage() {
      this.wishList = Storage.getLocalStorage("wishList", true);
      if (this.wishList) {
        const wishListItemIdx = this.wishList.findIndex(
          listItem => listItem.title === this.config.item.title
        );
        const isInStorage =
          !!this.wishList[wishListItemIdx] &&
          !!this.wishList[wishListItemIdx].downloads.find(
            downloadItem =>
              !!this.config.item.downloads &&
              !!this.config.item.downloads.find(
                configDownloadItem =>
                  downloadItem.url === configDownloadItem.url
              )
          );

        if (wishListItemIdx > -1 && isInStorage) {
          this.isDisabled = true;
        }
      }
    },
    updateBadge() {
      if (this.badge) {
        this.badge.style.transition = "none";
        this.badge.style.opacity = 1;
      }
    }
  },
  mounted() {
    this.badge = document.getElementById("wishListBadge");
    this.event = new CustomEvent("addToWishList");
    this.checkLocalStorage();
  }
};
</script>

<style module lang="scss">
@import "./WishListLink.scss";
</style>
